export const ORDER_STATE_MAPPING = [
	'FULFILLED',
	'IN_PROGRESS',
	'ON_HOLD',
	'OPEN',
	'PARTIALLY_FULFILLED',
	'PENDING_FULFILLMENT',
	'RESTOCKED',
	'SCHEDULED',
	'UNFULFILLED'
];
